enum DriverStatus {
  pickUp = "送り中",
  dropOff = "迎え中",
  returnOffice = "帰還中",
  waiting = "待機中",
  sendHome = "自宅送り中",
}

export default DriverStatus;
